/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type CloseSessionMutationVariables = Types.Exact<{
  input: Types.CloseTemporaryBackofficeSessionInput
}>

export type CloseSessionMutation = {
  __typename?: 'Mutation'
  closeTemporaryBackofficeSession: {
    __typename?: 'TemporaryBackofficeSession'
    id: string
    status: Types.TemporaryBackofficeSessionStatus
    closedAt: string | null
    customerDataModified: boolean | null
    closureNotes: string | null
    lifecycleEvents: Array<{
      __typename?: 'TemporaryBackofficeSessionLifecycleEvent'
      type: Types.TemporaryBackofficeSessionLifecycleEventType
      timestamp: string
      expiresAt: string | null
    }>
  }
}

export const CloseSessionDocument = gql`
    mutation CloseSession($input: CloseTemporaryBackofficeSessionInput!) {
  closeTemporaryBackofficeSession(input: $input) {
    id
    status
    closedAt
    customerDataModified
    closureNotes
    lifecycleEvents {
      type
      timestamp
      expiresAt
    }
  }
}
    `
export type CloseSessionMutationFn = Apollo.MutationFunction<
  CloseSessionMutation,
  CloseSessionMutationVariables
>

/**
 * __useCloseSessionMutation__
 *
 * To run a mutation, you first call `useCloseSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeSessionMutation, { data, loading, error }] = useCloseSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseSessionMutation,
    CloseSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CloseSessionMutation,
    CloseSessionMutationVariables
  >(CloseSessionDocument, options)
}
export type CloseSessionMutationHookResult = ReturnType<
  typeof useCloseSessionMutation
>
export type CloseSessionMutationResult =
  Apollo.MutationResult<CloseSessionMutation>
export type CloseSessionMutationOptions = Apollo.BaseMutationOptions<
  CloseSessionMutation,
  CloseSessionMutationVariables
>
